export const namespace = 'depthofmarket'
